import * as RootNavigation from "app/utils/RootNavigation.js";
import prefActions from "app/utils/prefActions";
import ENV from "app/utils/ENV";

const keyboardHelpers = {
  globalListener(e) {
    if (!ENV.WEB) return true;
    let url = window.location.href;
    // url = url.slice(0, url.lastIndexOf("/"));

    // console.log("global", e.metaKey, e.key);

    if (e.metaKey) {
      // NB: don't claim ⌘k globally — the editors use it to strike out text
      if (["j"].includes(e.key)) {
        e.preventDefault();
        let search = document.getElementById(`global-search-${url}`);
        // let nodes = document.querySelectorAll(`#global-search-${url}`);
        // let search = !!nodes?.length && nodes[nodes.length - 1];
        console.log("search", search);
        search?.focus();
        return false;
      } else if (["p"].includes(e.key)) {
        e.preventDefault();
        RootNavigation.popToTop();
        return false;
      } else if (["'"].includes(e.key)) {
        e.preventDefault();
        prefActions.cycleDetailsMode();
        return false;
      } else if (["/"].includes(e.key)) {
        e.preventDefault();
        // one keystroke can reach this listener twice (document keydown +
        // TextInput's synthetic onKeyPress) — debounce so the modal doesn't
        // toggle open and shut again
        let now = Date.now();
        if (now - (keyboardHelpers._lastShortcutsToggle || 0) > 100) {
          keyboardHelpers._lastShortcutsToggle = now;
          keyboardHelpers.onToggleShortcuts && keyboardHelpers.onToggleShortcuts();
        }
        return false;
      }
    } else if (document.activeElement.id == "body") {
      let ignoreKeys = ["Tab"];
      let key = e.nativeEvent?.key || e.key;
      if (
        String.fromCharCode(e.keyCode).match(/(\w|\s)/g) &&
        !ignoreKeys.includes(key)
      ) {
        e.preventDefault();
        let defaultFocus = document.getElementById(`default-focus-${url}`);
        // let nodes = document.querySelectorAll(`#default-focus-${url}`);
        // let defaultFocus = !!nodes?.length && nodes[nodes.length - 1];
        console.log("default", defaultFocus?.nodeName, e);
        if (!!defaultFocus) {
          if (["DIV"].includes(defaultFocus.nodeName)) {
            defaultFocus.click();
          } else if (["TEXTAREA"].includes(defaultFocus.nodeName)) {
            defaultFocus.focus();
          }
          return false;
        }
      }
    }
    return true;
  },
};

export default keyboardHelpers;
